import { REQUEST_SELECTOR } from '../constants';

const initialState = {
    loading: false,
    selectedRequest: "",
    error: null
}

const requestSelectorReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case REQUEST_SELECTOR.REQUEST_SELECTOR_LOAD:
            return {
                ...state,
                loading: true,
                selectedRequest: "",
                error: null
            }
        case REQUEST_SELECTOR.REQUEST_SELECTOR_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedRequest: payload.selectedRequest,
                error: null
            }
        case REQUEST_SELECTOR.REQUEST_SELECTOR_RESET:
            return {
                ...state,
                loading: false,
                selectedRequest: "",
                error: null
            }
        case REQUEST_SELECTOR.REQUEST_SELECTOR_FAIL:
            return {
                ...state,
                loading: true,
                selectedRequest: "",
                error: action.error
            }
        default:
            return state;
    }
}
export default requestSelectorReducer
